import React from "react";
import "bootstrap";

import "bootstrap/scss/bootstrap.scss";
import "font-awesome/scss/font-awesome.scss";
import "slick-carousel/slick/slick.scss";
import "slick-carousel/slick/slick-theme.scss";

import AppRouter from "./routes/AppRouter";
import "./styles/index.scss";

function App() {
  return <AppRouter />;
}

export default App;
